export default "__VITE_ASSET__Cud0VeCt__"